export default __webpack_public_path__ + "de2563c263d84ed0e786a3d1b6a97266.png";